import axios from "axios";

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const apiUrl = process.env.VUE_APP_API_URL;

export default {
    getTranslations(locale) {
        return axios.get(`${apiUrl}/api/translation?culture=${locale}`);
    }
}